
<div class="row">

  <div class="col-xl-6 col-sm-12 col-xs-12 mb-6">

    <div class="dx-field">
      <div class="dx-field-label">Oggetto </div>
      <div class="dx-field-value">

        <dx-text-area
          [height]="90"
          [(value)]="parametriStampa.oggetto"
          (onKeyDown)="onKeyDown($event)"
          >
        </dx-text-area>

        <!-- <dx-text-area (onKeyDown)="onKeyDown($event)" [(value)]="parametriStampa.oggetto"
        [autoResizeEnabled]="true" [minHeight]="10"
        [maxHeight]="50" class="style-text-area">

      </dx-text-area>-->




    </div>
  </div>

</div>

<div class="col-xl-6 col-sm-12 col-xs-12 mb-6">

  <div class="dx-field">
    <div class="dx-field-label">Luogo </div>
    <div class="dx-field-value">
      <dx-text-area
        [height]="90"
        [(value)]="parametriStampa.luogo"
        (onKeyDown)="onKeyDown($event)"
        >
      </dx-text-area>


    </div>
  </div>

</div>
</div>

<div class="row">
  <div class="col-xl-6 col-sm-12 col-xs-12 mb-6">
    <div class="dx-field">
      <div class="dx-field-label">Paragrafo 1 </div>
      <div class="dx-field-value">
        <dx-text-area
          [height]="90"
          [(value)]="parametriStampa.paragrafo1"
          (onKeyDown)="onKeyDown($event)"
          >
        </dx-text-area>

      </div>
    </div>
  </div>

  <div class="col-xl-6 col-sm-12 col-xs-12 mb-6">
    <div class="dx-field">
      <div class="dx-field-label">Paragrafo 2 </div>
      <div class="dx-field-value">
        <dx-text-area
          [height]="90"
          [(value)]="parametriStampa.paragrafo2"
          (onKeyDown)="onKeyDown($event)"
          >
        </dx-text-area>

      </div>
    </div>
  </div>

</div>

<div class="row">
  <div class="col-xl-6 col-sm-12 col-xs-12 mb-6">
    <div class="dx-field">
      <div class="dx-field-label">Paragrafo 3</div>
      <div class="dx-field-value">
        <dx-text-area
          [height]="90"
          [(value)]="parametriStampa.paragrafo3"
          (onKeyDown)="onKeyDown($event)"
          >
        </dx-text-area>

      </div>
    </div>
  </div>

  <div class="col-xl-6 col-sm-12 col-xs-12 mb-6">
    <div class="dx-field">
      <div class="dx-field-label">Paragrafo 4 </div>
      <div class="dx-field-value">
        <dx-text-area
          [height]="90"
          [(value)]="parametriStampa.paragrafo4"
          (onKeyDown)="onKeyDown($event)"
          >
        </dx-text-area>

      </div>
    </div>
  </div>

</div>

<div class="row">
  <div class="col-xl-6 col-sm-12 col-xs-12 mb-6">
    <div class="dx-field">
      <div class="dx-field-label">Footer 1</div>
      <div class="dx-field-value">
        <dx-text-area
          [height]="90"
          [(value)]="parametriStampa.footer1"
          (onKeyDown)="onKeyDown($event)"
          >
        </dx-text-area>

      </div>
    </div>
  </div>

  <div class="col-xl-6 col-sm-12 col-xs-12 mb-6">
    <div class="dx-field">
      <div class="dx-field-label">Footer 2 </div>
      <div class="dx-field-value">
        <dx-text-area
          [height]="90"
          [(value)]="parametriStampa.footer2"
          (onKeyDown)="onKeyDown($event)"
          >
        </dx-text-area>

      </div>
    </div>
  </div>

</div>

<div class="row">
  <div class="col-xl-6 col-sm-12 col-xs-12 mb-6">
    <div class="dx-field">
      <div class="dx-field-label">Footer 3</div>
      <div class="dx-field-value">
        <dx-text-area
          [height]="90"
          [(value)]="parametriStampa.footer3"
          (onKeyDown)="onKeyDown($event)"
          >
        </dx-text-area>

      </div>
    </div>
  </div>

  <div class="col-xl-6 col-sm-12 col-xs-12 mb-6">

  </div>

</div>

<div class="row">
  <div class="col-xl-6 col-sm-12 col-xs-12 mb-6">
    <div class="dx-field">
      <div class="dx-field-label">Header</div>

      <dx-file-uploader
        #HeaderUploader
        selectButtonText="Selezione file"
        labelText=""
        accept="image/*"
        uploadMode="useForm"
        width="400"
        (change)="getHeader($event)">
      </dx-file-uploader>


    </div>
  </div>
  @if (headerVisibile==true) {
    <div class="col-xl-6 col-sm-12 col-xs-12 mb-6">
      <img [src]="currentHeader"  width="400" alt="Testata corrente">
    </div>
  }



</div>

<div class="row">
  <div class="col-xl-6 col-sm-12 col-xs-12 mb-6">
    <div class="dx-field">
      <div class="dx-field-label">Firma</div>

      <dx-file-uploader
        #HeaderUploader
        selectButtonText="Selezione file"
        labelText=""
        accept="image/*"
        uploadMode="useForm"
        (change)="getFirma($event)">
      </dx-file-uploader>


    </div>
  </div>
  @if (firmaVisibile==true) {
    <div class="col-xl-6 col-sm-12 col-xs-12 mb-6">
      <img [src]="currentFirma" alt="Firma Corrente">
    </div>
  }



</div>

<div class="row">
  <div class="col-12" style="display: flex; gap: 10px;">
    <dx-button
      stylingMode="contained"
      text="Salva"
      icon="save"
      type="success"
      width="120"
      (onClick)="SalvaParametri($event)">
    </dx-button>

    <dx-button
      stylingMode="contained"
      text="Test Stampa report"
      icon="print"
      type="success"
      width="180"
      (onClick)="testStampaReport()">
    </dx-button>
  </div>
</div>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="visibleLoadPanel" [showIndicator]="true"
  [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
</dx-load-panel>

